export default "__VITE_ASSET__CUnUmAu1__"